import React, { useState, useEffect, useRef } from "react";
import "../../App.css";
import { BackToIndustryVerticalsButton } from "../layout/BackButton";
import QuickLinksSection1 from "../products/QuickLinksSection1";
// Training Services Page
function TrainingServicesPage({ handleNavClick }) {
  return (
    <section className="section training-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />
      <div className="section__container">
        <h2 className="section__title">Training Services</h2>
        <div className="training-content">
          <p>
            We provide Training in Geospatial technologies across various domains of applications and inter disciplinary studies, research and applications:
          </p>
          <ul>
            <li>(i) Drone/Aerial/Satellite image processing and feature extraction</li>
            <li>(ii) End-to-end training on:</li>
            <ul className="sub-list">
              <li>Image processing software</li>
              <li>GIS Techniques and Software</li>
              <li>Web-GIS</li>
              <li>Data creation, management, retrieval, analysis</li>
              <li>Data Visualization tools and techniques</li>
              <li>Terrain and cadastral survey using latest equipment and software</li>
            </ul>
          </ul>
        </div>
      </div>
      <QuickLinksSection1
        handleNavClick={handleNavClick}
        links={[
          { id: 'gis-services', title: 'GIS and Data Services' },
          { id: 'agriculture', title: 'Agriculture' },
          { id: 'environment', title: 'Environment' },
          { id: 'health', title: 'Health' },
          { id: 'education-research', title: 'Education & Research' }
        ]}
      />
    </section>
  );
}

export default TrainingServicesPage;
